import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';

import { colors, distances } from '../../styles/constants';

const SubLink = styled(NavLink)`
    display: block;
    background: transparent;
    font-size: 14px;
    min-height: 24px;
    padding-top: 4px;
    line-height: ${distances.small};
    font-weight: 400;
    text-decoration: none;
    color: #000000;
    border-right: 4px solid transparent;
    padding-left: 12px;
    padding-right: ${distances.small};
    cursor: pointer;
    transition: border-right 100ms ease-in-out;

    &:hover {
        background: rgba(0, 0, 255, 0.05);
    }

    &.active {
        background: rgba(0, 0, 255, 0.05);
        border-right: ${distances.tiny} solid ${colors.primary};
    }

    @media (max-width: 768px) {
        font-size: 11px;
        border-right: none;
        border-bottom: 2px solid transparent;
        padding-right: 12px;
        min-height: 40px;
        padding-top: 12px;
        padding-bottom: 12px;
        min-width: fit-content;
        &.active {
            background: rgba(0, 0, 255, 0.05);
            border-right: none;
            border-bottom: 2px solid ${colors.primary};
        }
    }
`;

export default SubLink;
